import { FC, memo } from 'react'
import type { Props } from '../types'

const LocationPin: FC<Props> = ({ size = 16, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 13 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.9 1.238c-2.925 0-5.318 2.435-5.318 5.468 0 2.124 1.344 4.17 2.797 5.742a19.57 19.57 0 0 0 2.52 2.28 19.57 19.57 0 0 0 2.521-2.28c1.454-1.572 2.798-3.618 2.798-5.742 0-3.033-2.393-5.468-5.318-5.468Zm0 14.815c-.155 0-.333-.103-.333-.103-.083-.047-.105-.072-.272-.196a20.752 20.752 0 0 1-2.783-2.5C2.01 11.628.4 9.296.4 6.706.4 3.044 3.298.053 6.9.053s6.5 2.991 6.5 6.653c0 2.59-1.61 4.922-3.112 6.548a20.746 20.746 0 0 1-2.783 2.5 7.343 7.343 0 0 1-.271.196s-.18.103-.334.103Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.9 5.278c-.75 0-1.379.627-1.379 1.428 0 .801.63 1.428 1.379 1.428s1.379-.627 1.379-1.428c0-.801-.63-1.428-1.38-1.428ZM4.34 6.706c0-1.43 1.133-2.613 2.56-2.613s2.56 1.183 2.56 2.613S8.328 9.32 6.9 9.32 4.34 8.137 4.34 6.706Z"
      clipRule="evenodd"
    />
  </svg>
)

export default memo(LocationPin)
